module.exports = __webpack_public_path__ + "img/slide-14-6.0566eac9.jpg";